import { render, staticRenderFns } from "./image-libs.vue?vue&type=template&id=23fc60ad&scoped=true&"
import script from "./image-libs.vue?vue&type=script&lang=js&"
export * from "./image-libs.vue?vue&type=script&lang=js&"
import style0 from "./image-libs.vue?vue&type=style&index=0&id=23fc60ad&lang=scss&scoped=true&"
import style1 from "./image-libs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fc60ad",
  null
  
)

export default component.exports